import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { LoginModule } from './core/modules/login/login.module';
import { DashboardModule } from './core/modules/dashboard/dashboard.module';
import { RouterModule } from '@angular/router';
import { AppLayoutModule } from './layouts/basic/app-layout.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthGuard } from './core/modules/login/auth.guard';
import { ResetPasswordModule } from './core/modules/reset-password/reset-password.module';
import { ManagementModule } from './core/modules/management/management.module';
import { SignUpModule } from './core/modules/sign-up/sign-up.module';
import { VerifyEmailModule } from './core/modules/verify-email/verify-email.module';
import { NonjointInviteModule } from './core/modules/nonjoint-invite/nonjoint-invite.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule,
    LoginModule,
    DashboardModule,
    AppLayoutModule,
    RouterModule,
    AppLayoutModule,
    ResetPasswordModule,
    ManagementModule,
    SignUpModule,
    VerifyEmailModule,
    NonjointInviteModule,
  ],
  bootstrap: [AppComponent],
  providers: [provideAnimationsAsync(), AuthGuard],
})
export class AppModule { }
